import { render, staticRenderFns } from "./SelectOtp.vue?vue&type=template&id=7f210924&lang=html"
import script from "./SelectOtp.vue?vue&type=script&lang=js"
export * from "./SelectOtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports